// Components==============
import { motion } from 'framer-motion';
import React from 'react';
// =========================

const AirBalloons = React.memo(() => (
    <>
        <motion.g
            initial={{ x: 0, y: 0 }}
            animate={{
                x: [0, 1, -1, 2, 0],
                y: [0, 5, -2, 3, -4, 4, 0],
            }}
            transition={{
                duration: 5,
                repeat: Infinity,
            }}
            id="RainbowAirBalloon"
        >
            <polygon
                points="2618.75 945.87 2597.89 957.9 2618.75 969.93 2639.6 957.9 2618.75 945.87"
                opacity=".1"
                strokeWidth="0"
            />
            <g>
                <path
                    d="m2651.49,825.58c0-19.13-14.66-34.63-32.74-34.63s-32.74,15.51-32.74,34.63c0,12.19,13.3,26.97,22.94,36.09-.08,2.92-.19,6.78-.19,7.75,0,3.33,4.46,6.03,9.96,6.03s9.96-2.7,9.96-6.03c0-1.51-.1-5.02-.18-7.71,9.65-9.11,22.99-23.92,22.99-36.13Z"
                    fill="#fbb03b"
                    strokeWidth="0"
                />
                <path
                    d="m2596.48,823.68c0,12.93,5.1,28.94,12.5,37.02,0,.03,0,.06,0,.09,0-.13,0-.26.01-.39.96,2.72,4.95,4.76,9.73,4.76-.46,0-.91-.02-1.35-.06-3.79-4.26-6.67-25.25-6.67-41.42,0-18.08,3.6-32.74,8.05-32.74-12.3,0-22.26,14.66-22.26,32.74Z"
                    fill="#78e271"
                    strokeWidth="0"
                />
                <path
                    d="m2620.13,865.1c3.79-4.27,6.67-25.25,6.67-41.41,0-18.08-3.6-32.74-8.05-32.74s-8.05,14.66-8.05,32.74c0,16.17,2.88,37.16,6.67,41.42.44.04.89.06,1.35.06s.95-.03,1.41-.07Z"
                    fill="#eacf5e"
                    strokeWidth="0"
                />
                <g opacity=".7">
                    <path
                        d="m2618.72,865.16c-4.78,0-8.77-2.04-9.73-4.76-.09,2.93-.23,7.89-.23,9.01,0,3.33,4.46,6.03,9.96,6.03s9.96-2.7,9.96-6.03c0-1.78-.13-6.3-.22-9.03-.95,2.73-4.95,4.77-9.74,4.77Z"
                        strokeWidth="0"
                    />
                </g>
                <polygon
                    points="2618.75 874.73 2602.84 883.91 2618.75 893.09 2634.66 883.91 2618.75 874.73"
                    fill="gray"
                    strokeWidth="0"
                />
                <polygon
                    points="2618.75 889.67 2602.84 898.85 2618.75 908.03 2634.66 898.85 2618.75 889.67"
                    fill="#3a3a3a"
                    strokeWidth="0"
                />
                <polygon
                    points="2602.65 883.8 2602.65 898.74 2618.75 908.03 2618.75 893.09 2602.65 883.8"
                    fill="#e8d9d4"
                    strokeWidth="0"
                />
                <polygon
                    points="2634.85 883.8 2634.85 898.74 2618.75 908.03 2618.75 893.09 2634.85 883.8"
                    fill="#ddc7c0"
                    strokeWidth="0"
                />
                <line
                    x1="2618.75"
                    y1="893.09"
                    x2="2618.75"
                    y2="872.38"
                    fill="none"
                    stroke="#ddc7c0"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.47"
                />
                <line
                    x1="2602.65"
                    y1="883.8"
                    x2="2609.38"
                    y2="870.21"
                    fill="none"
                    stroke="#ddc7c0"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.47"
                />
                <line
                    x1="2634.8"
                    y1="883.8"
                    x2="2628.06"
                    y2="870.21"
                    fill="none"
                    stroke="#ddc7c0"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.47"
                />
                <path
                    d="m2596.48,823.68c0-18.08,9.97-32.74,22.27-32.74-18.08,0-32.74,15.51-32.74,34.63,0,12.19,13.3,26.97,22.94,36.09,0-.34.02-.66.03-.97-7.4-8.08-12.5-24.09-12.5-37.02Z"
                    fill="#3db371"
                    strokeWidth="0"
                />
                <path
                    d="m2651.49,825.58c0-19.13-14.66-34.63-32.74-34.63,12.3,0,22.27,14.66,22.27,32.74,0,12.96-5.12,29.01-12.55,37.07,0,.3.02.62.03.96,9.65-9.11,22.99-23.92,22.99-36.13Z"
                    fill="#f44e4e"
                    strokeWidth="0"
                />
            </g>
        </motion.g>
        <motion.g
            initial={{ x: 0, y: 0 }}
            animate={{
                x: [0, 1, -1, 2, 0],
                y: [0, 5, -2, 3, -4, 4, 0],
            }}
            transition={{
                duration: 5,
                repeat: Infinity,
            }}
            id="RedWhiteAirBalloon"
        >
            <polygon
                points="5672.61 652.57 5651.76 664.61 5672.61 676.64 5693.47 664.61 5672.61 652.57"
                opacity=".1"
                strokeWidth="0"
            />
            <g>
                <path
                    d="m5705.35,532.28c0-19.13-14.66-34.63-32.74-34.63s-32.74,15.51-32.74,34.63c0,12.19,13.3,26.97,22.94,36.09-.08,2.92-.19,6.78-.19,7.75,0,3.33,4.46,6.03,9.96,6.03s9.96-2.7,9.96-6.03c0-1.51-.1-5.02-.18-7.71,9.65-9.11,22.99-23.92,22.99-36.13Z"
                    fill="#fff"
                    strokeWidth="0"
                />
                <path
                    d="m5650.35,530.39c0,12.93,5.1,28.94,12.5,37.02,0,.03,0,.06,0,.09,0-.13,0-.26.01-.39.96,2.72,4.95,4.76,9.73,4.76-.46,0-.91-.02-1.35-.06-3.79-4.26-6.67-25.25-6.67-41.42,0-18.08,3.6-32.74,8.05-32.74-12.3,0-22.26,14.66-22.26,32.74Z"
                    fill="#fff"
                    strokeWidth="0"
                />
                <path
                    d="m5674,571.8c3.79-4.27,6.67-25.25,6.67-41.41,0-18.08-3.6-32.74-8.05-32.74s-8.05,14.66-8.05,32.74c0,16.17,2.88,37.16,6.67,41.42.44.04.89.06,1.35.06s.95-.03,1.41-.07Z"
                    fill="#f44e4e"
                    strokeWidth="0"
                />
                <g opacity=".7">
                    <path
                        d="m5672.59,571.87c-4.78,0-8.77-2.04-9.73-4.76-.09,2.93-.23,7.89-.23,9.01,0,3.33,4.46,6.03,9.96,6.03s9.96-2.7,9.96-6.03c0-1.78-.13-6.3-.22-9.03-.95,2.73-4.95,4.77-9.74,4.77Z"
                        strokeWidth="0"
                    />
                </g>
                <polygon
                    points="5672.61 581.43 5656.7 590.62 5672.61 599.8 5688.53 590.62 5672.61 581.43"
                    fill="gray"
                    strokeWidth="0"
                />
                <polygon
                    points="5672.61 596.37 5656.7 605.56 5672.61 614.74 5688.53 605.56 5672.61 596.37"
                    fill="#3a3a3a"
                    strokeWidth="0"
                />
                <polygon
                    points="5656.51 590.51 5656.51 605.45 5672.61 614.74 5672.61 599.8 5656.51 590.51"
                    fill="#e8d9d4"
                    strokeWidth="0"
                />
                <polygon
                    points="5688.72 590.51 5688.72 605.45 5672.61 614.74 5672.61 599.8 5688.72 590.51"
                    fill="#ddc7c0"
                    strokeWidth="0"
                />
                <line
                    x1="5672.61"
                    y1="599.8"
                    x2="5672.61"
                    y2="579.09"
                    fill="none"
                    stroke="#ddc7c0"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.47"
                />
                <line
                    x1="5656.51"
                    y1="590.51"
                    x2="5663.24"
                    y2="576.92"
                    fill="none"
                    stroke="#ddc7c0"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.47"
                />
                <line
                    x1="5688.66"
                    y1="590.51"
                    x2="5681.93"
                    y2="576.92"
                    fill="none"
                    stroke="#ddc7c0"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.47"
                />
                <path
                    d="m5650.35,530.39c0-18.08,9.97-32.74,22.27-32.74-18.08,0-32.74,15.51-32.74,34.63,0,12.19,13.3,26.97,22.94,36.09,0-.34.02-.66.03-.97-7.4-8.08-12.5-24.09-12.5-37.02Z"
                    fill="#f44e4e"
                    strokeWidth="0"
                />
                <path
                    d="m5705.35,532.28c0-19.13-14.66-34.63-32.74-34.63,12.3,0,22.27,14.66,22.27,32.74,0,12.96-5.12,29.01-12.55,37.07,0,.3.02.62.03.96,9.65-9.11,22.99-23.92,22.99-36.13Z"
                    fill="#f44e4e"
                    strokeWidth="0"
                />
            </g>
        </motion.g>
        <motion.g
            initial={{ x: 0, y: 0 }}
            animate={{
                x: [0, 1, -1, 2, 0],
                y: [0, 5, -2, 3, -4, 4, 0],
            }}
            transition={{
                duration: 5,
                repeat: Infinity,
            }}
            id="PurpleAirBalloon"
        >
            <polygon
                points="6583.44 1349.2 6562.58 1361.23 6583.44 1373.26 6604.29 1361.23 6583.44 1349.2"
                opacity=".1"
                strokeWidth="0"
            />
            <g>
                <path
                    d="m6616.18,1228.91c0-19.13-14.66-34.63-32.74-34.63s-32.74,15.51-32.74,34.63c0,12.19,13.3,26.97,22.94,36.09-.08,2.92-.19,6.78-.19,7.75,0,3.33,4.46,6.03,9.96,6.03s9.96-2.7,9.96-6.03c0-1.51-.1-5.02-.18-7.71,9.65-9.11,22.99-23.92,22.99-36.13Z"
                    fill="#ff7bac"
                    strokeWidth="0"
                />
                <path
                    d="m6561.17,1227.01c0,12.93,5.1,28.94,12.5,37.02,0,.03,0,.06,0,.09,0-.13,0-.26.01-.39.96,2.72,4.95,4.76,9.73,4.76-.46,0-.91-.02-1.35-.06-3.79-4.26-6.67-25.25-6.67-41.42,0-18.08,3.6-32.74,8.05-32.74-12.3,0-22.26,14.66-22.26,32.74Z"
                    fill="#ff7bac"
                    strokeWidth="0"
                />
                <path
                    d="m6584.82,1268.43c3.79-4.27,6.67-25.25,6.67-41.41,0-18.08-3.6-32.74-8.05-32.74s-8.05,14.66-8.05,32.74c0,16.17,2.88,37.16,6.67,41.42.44.04.89.06,1.35.06s.95-.03,1.41-.07Z"
                    fill="#794dad"
                    strokeWidth="0"
                />
                <g opacity=".7">
                    <path
                        d="m6583.41,1268.49c-4.78,0-8.77-2.04-9.73-4.76-.09,2.93-.23,7.89-.23,9.01,0,3.33,4.46,6.03,9.96,6.03s9.96-2.7,9.96-6.03c0-1.78-.13-6.3-.22-9.03-.95,2.73-4.95,4.77-9.74,4.77Z"
                        strokeWidth="0"
                    />
                </g>
                <polygon
                    points="6583.44 1278.06 6567.53 1287.24 6583.44 1296.42 6599.35 1287.24 6583.44 1278.06"
                    fill="gray"
                    strokeWidth="0"
                />
                <polygon
                    points="6583.44 1293 6567.53 1302.18 6583.44 1311.36 6599.35 1302.18 6583.44 1293"
                    fill="#3a3a3a"
                    strokeWidth="0"
                />
                <polygon
                    points="6567.34 1287.13 6567.34 1302.07 6583.44 1311.36 6583.44 1296.42 6567.34 1287.13"
                    fill="#e8d9d4"
                    strokeWidth="0"
                />
                <polygon
                    points="6599.54 1287.13 6599.54 1302.07 6583.44 1311.36 6583.44 1296.42 6599.54 1287.13"
                    fill="#ddc7c0"
                    strokeWidth="0"
                />
                <line
                    x1="6583.44"
                    y1="1296.42"
                    x2="6583.44"
                    y2="1275.71"
                    fill="none"
                    stroke="#ddc7c0"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.47"
                />
                <line
                    x1="6567.34"
                    y1="1287.13"
                    x2="6574.07"
                    y2="1273.54"
                    fill="none"
                    stroke="#ddc7c0"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.47"
                />
                <line
                    x1="6599.49"
                    y1="1287.13"
                    x2="6592.75"
                    y2="1273.54"
                    fill="none"
                    stroke="#ddc7c0"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.47"
                />
                <path
                    d="m6561.17,1227.01c0-18.08,9.97-32.74,22.27-32.74-18.08,0-32.74,15.51-32.74,34.63,0,12.19,13.3,26.97,22.94,36.09,0-.34.02-.66.03-.97-7.4-8.08-12.5-24.09-12.5-37.02Z"
                    fill="#4262ea"
                    strokeWidth="0"
                />
                <path
                    d="m6616.18,1228.91c0-19.13-14.66-34.63-32.74-34.63,12.3,0,22.27,14.66,22.27,32.74,0,12.96-5.12,29.01-12.55,37.07,0,.3.02.62.03.96,9.65-9.11,22.99-23.92,22.99-36.13Z"
                    fill="#4262ea"
                    strokeWidth="0"
                />
            </g>
        </motion.g>
    </>
));

AirBalloons.displayName = 'AirBalloons';
export default AirBalloons;
